module.exports = __webpack_public_path__ + "static/media/context-menu-black.40338eb2.svg";